export const padToPatchVersion = (version: string) => {
  const dotCount = version.split('.').length - 1;
  if (dotCount === 0) return `${version}.0.0`;
  if (dotCount === 1) return `${version}.0`;
  return version;
};
